import { withFormikInputWrapper } from '@perpay-web/components/higher-order/WithFormikInputWrapper/WithFormikInputWrapper';
import PasswordInput from '@perpay-web/fintech/components/base/PasswordInput/PasswordInput';

const FormikPasswordInput = withFormikInputWrapper(PasswordInput);

export default FormikPasswordInput;
